function formatHours(hours: number): string {
  if (hours < 0) {
    return Math.abs(Math.round(hours)).toString();
  } else {
    return Math.abs(Math.floor(hours)).toString();
  }
}

export { formatHours };
